<template>
  <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}"
      class="dimmed_black" style="top:0;display:block;"></div>
    <!--popup 시작-->
    <div :style="{ 'z-index': (currentZIndex+1)}"
      class="rew19_popContainer big" id="pop_changeDate" style="display:block;">
      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit" v-if="viewData.paymentCase == '1' || viewData.paymentCase == '2'">배송일 변경</span>
          <span class="rew19_basketList_tit" v-else>자동 결제일 변경</span>
          <button class="rew19_basketList_btn" @click="onCancel"><span>닫기</span></button>
        </h2>
      </div>
      <div class="rew19_popup_cont">
        <dl class="rew19_select_table">
          <dt>
              <span class="rew19_table_tit" v-if="viewData.paymentCase == '1' || viewData.paymentCase == '2'">배송일</span>
              <span class="rew19_table_tit" v-else>자동 결제일</span>
          </dt>
          <dd>
            <ul class="rew19_transition_table">
              <li>
                <em class="with_type1">현재</em>
                <div class="txt_type" v-if="viewData.paymentCase == '1' || viewData.paymentCase == '2'">이번달 배송일 {{viewData.delivery_day}}일 <span v-if="viewData.chdelivery_day != null && viewData.chdelivery_day != '' && viewData.paymentCase != '2'"> (다음달 배송일 {{viewData.chdelivery_day}}일로 변경예정)</span></div>
                <div class="txt_type" v-else-if="viewData.paymentCase == '3'" >이번달 결제일 {{parseInt(viewData.delivery_day, 10)-7}}일 <span v-if="viewData.chdelivery_day != null && viewData.chdelivery_day != ''"> (다음달 결제일 {{parseInt(viewData.chdelivery_day, 10)-7}}일로 변경예정)</span></div>
                <div class="txt_type" v-else >이번달 결제일 {{viewData.delivery_day}}일 <span v-if="viewData.chdelivery_day != null && viewData.chdelivery_day != ''"> (다음달 결제일 {{viewData.chdelivery_day}}일로 변경예정)</span></div>
              </li>
              <li v-if="viewData.delivery_days_current.length > 0">
                <em class="with_type1">이번달</em>
                <div class="rew19_form_full limit">
                  <span class="rew19_form_full" v-if="viewData.paymentCase == '3'">
                    <select v-model="viewData.delivery_day_current" class="rew19_select_t1 autoFocus" >
                      <option value="0">원하시는 날짜를 선택해주세요</option>
                      <option v-for="(item) in viewData.delivery_days_current" :key="item"
                        :value="item">{{parseInt(item, 10)-7}}</option>
                    </select>
                  </span>
                  <span class="rew19_form_full" v-else>
                    <select v-model="viewData.delivery_day_current" class="rew19_select_t1 autoFocus" >
                      <option value="0">원하시는 날짜를 선택해주세요</option>
                      <option v-for="(item) in viewData.delivery_days_current" :key="item"
                        :value="item">{{item}}</option>
                    </select>
                  </span>
                </div>
              </li>
              <li>
                <em class="with_type1">다음달</em>
                <div class="rew19_form_full limit" v-if="viewData.paymentCase == '1' || viewData.paymentCase == '2'">
                  <span class="rew19_form_full">
                    <select v-model="viewData.delivery_day_next" class="rew19_select_t1 autoFocus" v-bind:disabled="viewData.paymentCase == '2'">
                      <option value="0" v-if="viewData.paymentCase == '1'">원하시는 날짜를 선택해주세요</option>
                      <option value="" v-if="viewData.paymentCase == '2'">서비스 개선 작업으로 인해 '다음달 변경'은 8월 21일부터 가능합니다.</option>
                      <option v-for="(item) in viewData.delivery_days_next" :key="item" :value="item" >{{item}} (결제일 {{parseInt(item, 10)-7}}일)</option>
                    </select>
                  </span>
                </div>
                <div class="rew19_form_full limit" v-if="viewData.paymentCase != '1' && viewData.paymentCase != '2'">
                  <span class="rew19_form_full" v-if="viewData.paymentCase == '3'">
                    <select v-model="viewData.delivery_day_next" class="rew19_select_t1 autoFocus">
                      <option value="0">원하시는 날짜를 선택해주세요</option>
                      <option v-for="(item) in viewData.delivery_days_next" :key="item" :value="item" >{{parseInt(item, 10)-7}}</option>
                    </select>
                  </span>
                  <span class="rew19_form_full" v-else>
                    <select v-model="viewData.delivery_day_next" class="rew19_select_t1 autoFocus">
                      <option value="0">원하시는 날짜를 선택해주세요</option>
                      <option v-for="(item) in viewData.delivery_days_next" :key="item" :value="item" >{{item}}</option>
                    </select>
                  </span>
                </div>
              </li>
            </ul>
          </dd>
        </dl>

        <ul class="rew19_dotList topLine" v-if="viewData.paymentCase == '1' || viewData.paymentCase == '2'">
          <li>배송 희망일 7일전에 결제됩니다.</li>
          <li><span class="fontB">수령 희망일 8일(1일 결제), 9일(2일 결제), 10일(3일 결제), 27일(20일 결제)은</span> 배송이 집중되어 희망일 선택이 불가합니다. 원활한 서비스 제공을 위해 다른 날짜를 선택하여 주시기 바랍니다.</li>
        </ul>
        <ul class="rew19_dotList topLine" v-else>
          <li>결제 후 3일 이내에 배송됩니다.</li>
          <li><span class="fontB">자동 결제일 3일, 22일, 23일은</span> 주문량이 집중되어 선택이 불가합니다. 원활한 서비스 제공을 위해 다른 날짜를 선택하여 주시기 바랍니다.</li>
          <li><span>자동 결제일 선택 제한은 상황에 따라 변경될 수 있습니다.</span></li>
        </ul>
      </div><!--//rew19_popup_cont-->

      <div class="rew19_popup_btn rew19_clear">
          <button class="rew19_popHarf disabled" @click="onCancel">취소</button>
          <button class="rew19_popHarf activation" @click="onOk">확인</button>
      </div>
    </div>
  </div>
</template>
<script>
import * as ErrMsg from "@/utils/error_msg";

export default {
  name: 'DeliveryDateDialog',
  components: {  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentZIndex : 2000,

      viewData : {
        delivery_day : null,
        delivery_days_current : [],
        delivery_day_current : null,
        delivery_days_next : [],
        delivery_day_next : null,
        paymentCase : null,
      }
    }
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);

      show && this.$nextTick(() => {
        let _this = this;
        _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

        this.$el.focus();
      })
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102);
    })
  },
  mounted() {
    let _this = this;

  },
  methods :{
    onClose(response) {
      let _this = this;

      let resData = {
        delivery_day_current :
          (_this.viewData.delivery_days_current && _this.viewData.delivery_days_current.length > 0)
          ? _this.viewData.delivery_day_current : _this.viewData.delivery_day,
        delivery_day_next :
          (_this.viewData.delivery_days_next && _this.viewData.delivery_days_next.length > 0)
          ? _this.viewData.delivery_day_next : _this.viewData.delivery_day,
      };

      _this.$emit('close', response, resData);
    },
    onCancel(){
      this.onClose(false);
    },
    onOk() {
      let _this = this;

      if(_this.viewData.delivery_days_current){
        if(_this.viewData.delivery_day_current == "0"){
          _this.$dialogs.alert("이번달 수령 희망일 선택하여 주시기 바랍니다.", {title: "이번달 수령일 확인"})
          .then(res => {});
          return false;
        }
      }

      if(_this.viewData.delivery_days_next){
        if(_this.viewData.delivery_day_next == "0"){
          if(_this.viewData.paymentCase != "2"){
            _this.$dialogs.alert("다음달 수령 희망일 선택하여 주시기 바랍니다.", {title: "다음달 수령일 확인"})
            .then(res => {});
            return false;
          }
        }
      }

      _this.onClose(true);

    },

    /**
     * API Request
     */

    /**
     * Local
     */
    initData : function(data){
      let _this = this;

      _this.viewData = {
        ..._this.viewData,
        ...data,
      };

      if( _this.viewData.delivery_days_current.length > 0){
        // _this.viewData.delivery_days_current = _this.viewData.delivery_days_current.filter(item=>{
        //   if(item != 10){
        //     return item;
        //   }
        // });
        if(_this.viewData.delivery_days_current.includes(data.delivery_day)){
          _this.viewData.delivery_day_current = 0;
        }else{
          _this.viewData.delivery_day_current = 0;
        }

      }

      if( _this.viewData.delivery_days_next.length > 0){
        // _this.viewData.delivery_days_next = _this.viewData.delivery_days_next.filter(item=>{
        //   if(item != 10){
        //     return item;
        //   }
        // });
        if(_this.viewData.delivery_days_next.includes(data.delivery_day)){
          if(_this.viewData.chdelivery_day != null && _this.viewData.chdelivery_day != ''){
            _this.viewData.delivery_day_next = 0;
          }else{
           _this.viewData.delivery_day_next = 0;
          }
        }else{
          _this.viewData.delivery_day_next = 0;
        }
      }

    },
  }
}
</script>
<style>
.fontB {font-weight: bold; color: #000;}
</style>



// WEBPACK FOOTER //
// src/components/popup/DeliveryDateDialog.vue